import { Link as RouterLink } from 'react-router'
import { EmailOutlined, FolderOutlined, PhoneOutlined, PlaceOutlined } from '@mui/icons-material'
import { Box, Grid, Link, Skeleton, Typography, useTheme } from '@mui/material'

import HighlightText from '../../../components/highlight-text'
import useSharedStyles from '../../../utils/shared.styles'
import { useSearchFilters } from '../helpers'
import useStyles from '../index.styles'

export const SkeletonResultItem = () => {
  const classes = useStyles
  return (
    <Box sx={classes.resultItem}>
      <Skeleton width="290px" />
      <Skeleton width="380px" height="34px" />
      <Skeleton width="320px" />
    </Box>
  )
}

interface IProps {
  title: string
  linkTo: string
  parentText?: string
  identifierText?: string
  address?: string
  email?: string
  phone?: string
  folders?: string
  itemType?: string
  isDeactivated?: boolean
}

const ResultItem = (props: IProps) => {
  const { title, linkTo, parentText, identifierText, address, email, phone, folders, itemType, isDeactivated } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()
  const { q } = useSearchFilters()

  return (
    <Box sx={classes.resultItem}>
      <Grid container={true} sx={[sharedClasses.centerContentVertical, { justifyContent: 'space-between' }]}>
        <Link component={RouterLink} variant="body1" className="fs-exclude" sx={classes.resultItemLink} underline="hover" to={linkTo}>
          <HighlightText text={title} query={q} isDeactivated={isDeactivated} />
        </Link>
        <Typography variant="caption" sx={sharedClasses.secondaryText}>
          {itemType}
        </Typography>
      </Grid>
      <div>
        {identifierText && (
          <Typography variant="body2" className="fs-exclude" sx={classes.resultItemContact}>
            <HighlightText text={identifierText} query={q} />
          </Typography>
        )}
        {address && (
          <Typography variant="body2" className="fs-exclude" sx={{ ...classes.resultItemContact(theme), ...classes.resultItemAddress }}>
            <PlaceOutlined sx={classes.resultItemContactIcon} />
            <HighlightText text={address} query={q} />
          </Typography>
        )}
        {email && (
          <Typography variant="body2" className="fs-exclude" sx={classes.resultItemContact}>
            <EmailOutlined sx={classes.resultItemContactIcon} />
            <HighlightText text={email} query={q} />
          </Typography>
        )}
        {phone && (
          <Typography variant="body2" className="fs-exclude" sx={classes.resultItemContact}>
            <PhoneOutlined sx={classes.resultItemContactIcon} />
            <HighlightText text={phone} query={q} />
          </Typography>
        )}
        {folders && (
          <Typography variant="body2" className="fs-exclude" sx={classes.resultItemContact}>
            <FolderOutlined sx={classes.resultItemContactIcon} />
            <HighlightText text={folders} query={q} />
          </Typography>
        )}
      </div>
      {parentText && (
        <Typography variant="body2" className="fs-exclude" sx={sharedClasses.secondaryText}>
          <HighlightText text={parentText} query={q} />
        </Typography>
      )}
    </Box>
  )
}

export default ResultItem
